<div class="flex align-items-center gap-15">
  <img src="/assets/img/broken.png" width="75" />
  <div class="flex column">
    @if (pageTitle) {
      <div class="header-2" translate>not found.label</div>
    }
    <div translate>not found.text</div>
  </div>
</div>
